import { render, staticRenderFns } from "./TransfersTable.vue?vue&type=template&id=40013b12&"
import script from "./TransfersTable.vue?vue&type=script&lang=js&"
export * from "./TransfersTable.vue?vue&type=script&lang=js&"
import style0 from "./TransfersTable.vue?vue&type=style&index=0&id=40013b12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports